<template>
  <div class="rightTools">
    <div class="body" :class="{ hasBackTop: scrollTop }">
      <div
        class="item"
        v-for="(item,index) in list"
        :key="index"
        @click="goLink(index)">
        <i class="toolIcon" :class="item.icon"></i>
        <div class="name">
          {{item.name}}
        </div>
      </div>
      <div class="backTopPanel">
        <div class="backTopPanelInner">
          <div class="item backTop" @click="goTop">
            <i class="toolIcon el-icon-arrow-up"></i>
            <div class="name">
                返回顶部
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components:{
  },
  data() {
    return {
      list:[
        {name:'下载APP',icon:'el-icon-mobile-phone'},
        {name:'联系客服',icon:'el-icon-service'},
        // {name:'估价直播',img:'gjzb.png'},
        {name:'售后案例',icon:'el-icon-document-checked'},
        {name:'业务介绍',icon:'el-icon-s-cooperation'},
        {name:'投诉建议',icon:'el-icon-warning-outline'},
        {name:'最近浏览',icon:'el-icon-view'},
        {name:'帮助中心',icon:'el-icon-question'},
        // {name:'招贤纳士',img:'zxns.png'},
        {name:'有奖问卷',icon:'el-icon-tickets'},
      ],
      routeLink: [{
        // 下载app
        name: 'Download'
      },{
        // 联系客服
        name: 'CusSerCenter'
      },{
        // 售后案例
        name: 'Legal',
        query: {id:'113',parent_id:'13'}
      },{
        // 业务介绍
        name:'TradeTip',
        query:{id:'108',parent_id:'83'}
      },{
        // 投诉建议
        name:'TradeTip',
        query:{id:'112',parent_id:'83'}
      },{
        // 最近浏览
        name: 'AccHistory'
      }, {
        // 帮助中心
        name: 'helpCenter'
      },
      // {
      //   // 招贤纳士
      //   name: 'About',
      //   query: {id: '120',parent_id: '18'}
      // },
      {
        // 有奖问卷
        name: 'Questionnaire'
      }],
      scrollTop:0
    }
  },
  computed: {
    switchOldTDWeb() {
      const query = this.$route.query.gameCode;
      return this.$route.fullPath === '/goodsList?gameCode=TYMYD'||this.$route.name === 'goodsDetails' && (query==='tymyd'||query==='TYMYD');
    }
  },
  watch: {
    $route(to) {
    },
  },
  created() {
    this.switchTool()
    this.close = localStorage.getItem('closeRight') === 'true' ? true : null;
    if (this.$route.query.seo == 1) {
      this.list.shift()
      this.routeLink.shift()
    }
  },
  methods: {
    // 路由跳转
    goLink(index){
      this.$sensorsTrack.PCNavigationBarClick(index + 1,this.list[index].name)
      this.$router.push(this.routeLink[index])
    },
    switchTool() {
      this.close = !this.close;
      localStorage.setItem('closeRight',this.close)
    },
    /**
     * 生成下载app二维码
     */
    getQCode(){
      new QRCode(this.$refs.qrCodeDiv, {
        text: 'https://mobile.pxb7.com/pages/downloadApp/downloadApp',
        width: 120,
        height: 120,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    },
    /**
     * 监听滚动条
     */
    scrollToTop() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    /**
     * 回到顶部
     */
    goTop(){
      cancelAnimationFrame(this.timer)
      const self = this
      self.timer = requestAnimationFrame(function fn () {
        const oTop = document.body.scrollTop || document.documentElement.scrollTop
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop = oTop - 150
          self.timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(self.timer)
        }
      })
    }
  },
  mounted() {

    window.addEventListener('scroll', this.scrollToTop)
  },
}
</script>
<style scoped lang="less">
.rightTools {
  position: fixed;
  right: 18px;
  top: 96px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;

  .body{
    position: relative;
    transition: box-shadow 0.22s ease,
      border-color 0.22s ease,
      transform 0.22s ease;
    width: 72px;
    box-sizing: border-box;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    box-shadow: 0 12px 30px rgba(26, 29, 36, 0.11);
    border-radius: 4px;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    display: flex;
    flex-direction: column;
    text-align: center;
    padding: 8px 6px;

    &:hover{
      border-color: rgba(26, 29, 36, 0.26);
      box-shadow: 0 16px 38px rgba(26, 29, 36, 0.15);
    }

    .item{
      cursor: pointer;
      min-height: 54px;
      box-sizing: border-box;
      border-radius: 4px;
      margin-bottom: 3px;
      padding: 5px 0;
      color: var(--text-secondary, #5A5F6B);
      transition: background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease, transform 0.2s ease;

      &:hover{
        background: var(--bg-tag, #F0EDE8);
        box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.22), 0 9px 22px rgba(26, 29, 36, 0.16);
        color: var(--text-main, #1A1D24);
        transform: translateY(-2px);

        .toolIcon{
          animation: toolIconShake 1.05s ease-in-out infinite;
          color: var(--primary, #FF5A1F);
          filter: drop-shadow(0 3px 6px rgba(255, 90, 31, 0.22));
          transform: translateY(-1px) scale(1.12);
        }

        .name{
          color: var(--text-main, #1A1D24);
          font-weight: 500;
        }
      }

      .toolIcon{
        width: 32px;
        height: 30px;
        display: block;
        color: var(--text-main, #1A1D24);
        font-size: 24px;
        line-height: 30px;
        margin: 0 auto 1px;
        transition: color 0.2s ease, filter 0.2s ease, transform 0.2s ease;
      }
      .name{
        text-align: center;
        color: inherit;
        font-size: 12px;
        line-height: 17px;
        white-space: nowrap;
        transition: color 0.2s ease;
      }

      &.backTop{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 50px;
        min-height: 0;
        border-radius: 4px;
        padding: 0;
        opacity: 0;
        transform: translateY(6px);
        transition: opacity 0.22s ease 0.08s,
          transform 0.32s cubic-bezier(0.16, 1, 0.3, 1),
          background 0.2s ease,
          box-shadow 0.2s ease,
          color 0.2s ease;

        .toolIcon{
          height: 26px;
          font-size: 21px;
          line-height: 26px;
          margin-bottom: 2px;
        }

        &:hover{
          .toolIcon{
            animation: none;
          }
        }
      }
    }

    .backTopPanel{
      display: grid;
      grid-template-rows: 0fr;
      opacity: 0;
      transition: grid-template-rows 0.34s cubic-bezier(0.16, 1, 0.3, 1),
        opacity 0.22s ease;

      .backTopPanelInner{
        padding-top: 0;
      }
    }

    .backTopPanelInner{
      position: relative;
      min-height: 0;
      overflow: hidden;
      padding-top: 8px;
      transform: translateY(6px);
      transition: padding-top 0.34s cubic-bezier(0.16, 1, 0.3, 1),
        transform 0.34s cubic-bezier(0.16, 1, 0.3, 1);

      &::before{
        content: '';
        position: absolute;
        top: 3px;
        left: 8px;
        right: 8px;
        height: 1px;
        background: var(--border-soft, #E8E4DE);
        pointer-events: none;
      }
    }

    &.hasBackTop{
      .backTopPanel{
        grid-template-rows: 1fr;
        opacity: 1;
      }

      .backTopPanelInner{
        padding-top: 8px;
        overflow: visible;
        transform: translateY(0);
      }

      .item.backTop{
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  @keyframes toolIconShake {
    0% {
      transform: translateY(-1px) scale(1.12) rotate(0deg);
    }
    10% {
      transform: translateY(-1px) scale(1.12) rotate(-18deg);
    }
    20% {
      transform: translateY(-1px) scale(1.12) rotate(16deg);
    }
    30% {
      transform: translateY(-1px) scale(1.12) rotate(-13deg);
    }
    40% {
      transform: translateY(-1px) scale(1.12) rotate(10deg);
    }
    50% {
      transform: translateY(-1px) scale(1.12) rotate(-6deg);
    }
    60% {
      transform: translateY(-1px) scale(1.12) rotate(3deg);
    }
    70%,
    100% {
      transform: translateY(-1px) scale(1.12) rotate(0deg);
    }
  }
}
</style>
